import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Check, X, ArrowRight, ShieldCheck, Video, Phone, 
  Unlock, AlertTriangle, TrendingUp, FileCheck, Ban, MessageSquare,
  Target, Zap, Scale, Award, CreditCard, ArrowLeft, Star, 
  BookOpen, UserCheck, AlertCircle, DollarSign, Rocket, CheckCircle
} from 'lucide-react';
import CheckoutModal from '../components/landing/CheckoutModal';
import AfterPaymentBlock from '../components/catalog/AfterPaymentBlock';
import { usePrices } from '../context/PricesContext';

// Approved Status Image
const APPROVED_IMAGE = 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/u5ogs3ri_image.png';

// Testimonial images
const TESTIMONIALS = [
  { image: 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/37x4hwua_image.png' },
  { image: 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/ppwour7c_image.png' },
  { image: 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/9ksgmtis_image.png' },
  { image: 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/6iis634k_image.png' },
  { image: 'https://customer-assets.emergentagent.com/job_45a602a6-d012-417b-95a5-886403eb825e/artifacts/7g8bzlny_image.png' },
];

// Before/After items
const beforeItems = [
  { icon: Ban, text: 'Амазон постоянно отказывал' },
  { icon: AlertTriangle, text: 'Каждый закрытый товар — упущенная возможность' },
  { icon: AlertTriangle, text: 'Боюсь отправлять инвойсы' },
  { icon: AlertTriangle, text: 'Не уверен, что мой поставщик нормальный' },
  { icon: AlertTriangle, text: 'Вдруг забанят, не туда нажму' },
  { icon: MessageSquare, text: 'Амазон отбрасывает шаблонными ответами' },
  { icon: X, text: 'Амазон называет мой инвойс розничным' },
];

const afterItems = [
  { icon: Check, text: 'Знаю точно, что делаю на каждом шаге' },
  { icon: Zap, text: 'За двое суток могу открыть много брендов' },
  { icon: FileCheck, text: 'Пробил автоотказы, вижу статус APPROVED' },
  { icon: Target, text: 'Знаю, что хочет видеть Амазон в инвойсе' },
  { icon: TrendingUp, text: 'На кучу шагов впереди конкурентов' },
  { icon: ShieldCheck, text: 'Знаю критерии поставщика идеально — без банов' },
  { icon: Scale, text: 'Куча возможностей масштабировать бизнес' },
];

// Result items
const resultItems = [
  'знаете точный порядок действий при ангейтинге',
  'понимаете, какие инвойсы и поставщики проходят',
  'открываете закрытые бренды без бесконечных отказов',
  'проходите автоотказы и доводите до APPROVED',
  'получаете доступ к брендам с меньшей конкуренцией и выше маржой',
];

const expertisePoints = [
  { num: 1, text: 'Критерии инвойса, которые "пробивают"' },
  { num: 2, text: 'Как донести Амазону, что ваш поставщик "трастовый"' },
  { num: 3, text: 'Как собрать данные так, чтобы у Амазон не было выбора кроме "APPROVED"' },
  { num: 4, text: 'Все критерии инвойса, поставщика, верификации на каждом этапе' },
];

// What's included
const courseContent = [
  {
    num: 1,
    title: 'Урок 1',
    desc: 'Как Amazon реально проверяет инвойсы (ключевые требования, red flags)',
    icon: BookOpen,
  },
  {
    num: 2,
    title: 'Урок 2',
    desc: 'Как выбрать поставщика, которого Amazon примет',
    icon: UserCheck,
  },
  {
    num: 3,
    title: 'Урок 3',
    desc: 'Как проходить автоотказы и доводить до APPROVED',
    icon: FileCheck,
  },
  {
    num: 4,
    title: 'Личный созвон',
    desc: 'Разбор твоего бренда / инвойса / поставщика',
    icon: Phone,
  },
];

// Image Modal Component
const ImageModal = ({ isOpen, onClose, imageSrc }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/95 backdrop-blur-sm cursor-zoom-out"
      onClick={onClose}
    >
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 w-12 h-12 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors z-10"
      >
        <X className="w-6 h-6" />
      </button>
      <img 
        src={imageSrc} 
        alt="Enlarged" 
        className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

const UngatingPage = () => {
  const [checkoutData, setCheckoutData] = useState({ isOpen: false, packageId: '', packageName: '', price: 0 });
  const [zoomedImage, setZoomedImage] = useState(null);
  const { getPrice } = usePrices();
  const price = getPrice('ungating');

  const handleCheckout = () => {
    setCheckoutData({ 
      isOpen: true, 
      packageId: 'ungating', 
      packageName: 'Ангейтинг — Открытие брендов', 
      price: price 
    });
  };

  const closeCheckout = () => {
    setCheckoutData({ isOpen: false, packageId: '', packageName: '', price: 0 });
  };

  return (
    <div className="min-h-screen bg-[#050506]">
      {/* Image Modal */}
      <ImageModal 
        isOpen={!!zoomedImage} 
        onClose={() => setZoomedImage(null)} 
        imageSrc={zoomedImage} 
      />
      
      {/* Checkout Modal */}
      <CheckoutModal 
        isOpen={checkoutData.isOpen}
        onClose={closeCheckout}
        packageId={checkoutData.packageId}
        packageName={checkoutData.packageName}
        price={checkoutData.price}
        discountMode={false}
      />

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-xl border-b border-zinc-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl blur opacity-40 group-hover:opacity-70 transition-opacity" />
                <div className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center shadow-lg">
                  <span className="text-black font-black text-lg">A</span>
                </div>
              </div>
              <div>
                <span className="text-white font-bold text-lg group-hover:text-amber-400 transition-colors">Amazon</span>
                <span className="text-zinc-400 font-medium text-lg ml-1">Wholesale</span>
              </div>
            </Link>
            
            <Link 
              to="/catalog"
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-zinc-800 border border-zinc-700 text-zinc-300 hover:text-white hover:bg-zinc-700 transition-all"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm font-medium">В каталог</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-24 pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Product Card */}
          <div className="relative mb-16">
            {/* Glow */}
            <div className="absolute -inset-3 bg-gradient-to-r from-amber-500/20 via-orange-500/30 to-amber-500/20 rounded-[2rem] blur-2xl" />
            
            {/* Card */}
            <div className="relative bg-gradient-to-b from-zinc-900 to-zinc-950 rounded-[1.5rem] border border-amber-500/30 overflow-hidden">
              
              {/* Header */}
              <div className="relative p-8 sm:p-10 bg-gradient-to-b from-amber-500/10 to-transparent border-b border-amber-500/20">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                  <div className="flex items-center gap-5">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-xl shadow-amber-500/30">
                      <Unlock className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                    </div>
                    <div>
                      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white">Ангейтинг</h1>
                      <p className="text-amber-300 text-lg sm:text-xl mt-1">Открытие закрытых брендов на Amazon</p>
                    </div>
                  </div>
                  <div className="text-left lg:text-right">
                    <p className="text-5xl sm:text-6xl font-black text-amber-400">${price}</p>
                    <p className="text-zinc-500 text-sm mt-1">единоразово</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 sm:p-10 space-y-10">
                
                {/* What is Ungating */}
                <div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center">
                      <span className="text-amber-400 font-bold text-xl">?</span>
                    </span>
                    Что такое ангейтинг?
                  </h3>
                  <p className="text-zinc-300 text-lg sm:text-xl leading-relaxed">
                    <span className="text-white font-semibold">Ангейтинг (Ungating)</span> — это процесс получения разрешения от Amazon 
                    на продажу закрытых (gated) брендов и категорий. Многие прибыльные бренды требуют специального одобрения, 
                    и без правильного подхода Amazon будет отказывать снова и снова.
                  </p>
                </div>

                {/* Why you need it */}
                <div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                      <Target className="w-5 h-5 text-emerald-400" />
                    </span>
                    Зачем нужен?
                  </h3>
                  <p className="text-zinc-300 text-lg sm:text-xl leading-relaxed">
                    Закрытые бренды = <span className="text-emerald-400 font-semibold">меньше конкуренции</span> и 
                    <span className="text-emerald-400 font-semibold"> выше маржа</span>. 
                    Пока другие продавцы мучаются с открытием, вы уже продаёте и зарабатываете на этих товарах.
                  </p>
                </div>

                {/* What's Included */}
                <div className="p-6 sm:p-8 rounded-2xl bg-gradient-to-b from-violet-500/10 to-violet-900/10 border border-violet-500/30">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-xl bg-violet-500/20 flex items-center justify-center">
                      <Video className="w-5 h-5 text-violet-400" />
                    </span>
                    Что входит:
                  </h3>
                  <div className="space-y-4">
                    {courseContent.map((item) => (
                      <div 
                        key={item.num}
                        className="flex items-start gap-4 p-4 rounded-xl bg-zinc-800/50 border border-zinc-700/50"
                      >
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                          <item.icon className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <p className="text-white font-bold text-lg">{item.title}</p>
                          <p className="text-zinc-400 text-base">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Before/After Grid */}
                <div className="grid lg:grid-cols-2 gap-6">
                  {/* Before */}
                  <div className="p-6 rounded-2xl bg-red-500/5 border border-red-500/20">
                    <h4 className="text-red-400 font-bold text-xl sm:text-2xl mb-5 flex items-center gap-3">
                      <X className="w-6 h-6" />
                      Что у вас было ДО
                    </h4>
                    <div className="space-y-4">
                      {beforeItems.map((item, i) => (
                        <div key={i} className="flex items-start gap-4">
                          <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <item.icon className="w-4 h-4 text-red-400" />
                          </div>
                          <span className="text-zinc-400 text-base sm:text-lg">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* After */}
                  <div className="p-6 rounded-2xl bg-emerald-500/5 border border-emerald-500/20">
                    <h4 className="text-emerald-400 font-bold text-xl sm:text-2xl mb-5 flex items-center gap-3">
                      <Check className="w-6 h-6" />
                      ПОСЛЕ
                    </h4>
                    <div className="space-y-4">
                      {afterItems.map((item, i) => (
                        <div key={i} className="flex items-start gap-4">
                          <div className="w-8 h-8 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <item.icon className="w-4 h-4 text-emerald-400" />
                          </div>
                          <span className="text-zinc-300 text-base sm:text-lg">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Approved Status Image */}
                <div className="text-center">
                  <p className="text-zinc-400 text-lg sm:text-xl mb-6">
                    Признай, ты хочешь видеть этот статус часто? <span className="text-white font-semibold">Просто нормально продавать.</span>
                  </p>
                  <div 
                    className="relative inline-block cursor-zoom-in group"
                    onClick={() => setZoomedImage(APPROVED_IMAGE)}
                  >
                    <div className="absolute -inset-3 bg-gradient-to-r from-emerald-500/30 to-green-500/30 rounded-2xl blur-xl group-hover:blur-2xl transition-all" />
                    <img 
                      src={APPROVED_IMAGE} 
                      alt="Amazon Approved Status" 
                      className="relative rounded-xl border-2 border-emerald-500/30 max-w-full h-auto shadow-2xl shadow-emerald-500/20 group-hover:scale-[1.02] transition-transform"
                      style={{ maxHeight: '400px' }}
                    />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="px-4 py-2 rounded-full bg-black/80 text-white text-sm font-medium">
                        Нажмите чтобы увеличить
                      </div>
                    </div>
                  </div>
                </div>

                {/* Our Expertise */}
                <div className="p-6 sm:p-8 rounded-2xl bg-amber-500/5 border border-amber-500/20">
                  <h4 className="text-amber-400 font-bold text-xl sm:text-2xl mb-5 flex items-center gap-3">
                    <Award className="w-6 h-6" />
                    Одни из лучших в открытии брендов
                  </h4>
                  <p className="text-zinc-400 text-base sm:text-lg mb-6">
                    И это не шутка. Мы изучали ангейтинг долгие месяцы, купили множество скриншотов внутри Amazon. Мы знаем:
                  </p>
                  <div className="grid sm:grid-cols-2 gap-4">
                    {expertisePoints.map((point) => (
                      <div key={point.num} className="flex items-start gap-4 p-4 rounded-xl bg-zinc-800/50">
                        <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 text-black font-bold">
                          {point.num}
                        </div>
                        <span className="text-zinc-300 text-sm sm:text-base">{point.text}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Testimonials */}
                <div>
                  <h4 className="text-white font-bold text-xl sm:text-2xl mb-6 flex items-center gap-3">
                    <Star className="w-6 h-6 text-amber-400" />
                    Отзывы учеников
                  </h4>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {TESTIMONIALS.map((testimonial, i) => (
                      <div 
                        key={i}
                        className="relative cursor-zoom-in group overflow-hidden rounded-xl border border-zinc-700 hover:border-amber-500/50 transition-all"
                        onClick={() => setZoomedImage(testimonial.image)}
                      >
                        <img 
                          src={testimonial.image} 
                          alt={`Отзыв ${i + 1}`}
                          className="w-full h-auto group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-4">
                          <span className="text-white text-sm font-medium">Нажмите чтобы увеличить</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Result Section */}
                <div className="p-6 sm:p-8 rounded-2xl bg-gradient-to-b from-amber-500/10 to-amber-900/10 border border-amber-500/30">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 flex items-center gap-3">
                    <Rocket className="w-7 h-7 text-amber-400" />
                    РЕЗУЛЬТАТ
                  </h3>
                  <p className="text-zinc-300 text-base sm:text-lg mb-4">После прохождения продукта вы:</p>
                  <div className="space-y-3">
                    {resultItems.map((item, i) => (
                      <div key={i} className="flex items-start gap-3 p-3 rounded-lg bg-zinc-800/50">
                        <CheckCircle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                        <span className="text-zinc-300 text-sm sm:text-base">{item}</span>
                      </div>
                    ))}
                  </div>
                  <p className="mt-6 text-amber-400 font-bold text-lg sm:text-xl text-center">
                    Итог: статус APPROVED как рабочий инструмент, а не редкое событие.
                  </p>
                </div>

                {/* After Payment Block */}
                <AfterPaymentBlock />

                {/* CTA Section */}
                <div className="text-center space-y-6 pt-8 border-t border-zinc-800">
                  <p className="text-zinc-400 text-xl sm:text-2xl">
                    Хочешь и дальше мучиться? <span className="text-white font-bold">Не надо.</span>
                  </p>
                  
                  {/* Price Block */}
                  <div className="inline-block p-6 sm:p-8 rounded-2xl bg-gradient-to-b from-amber-500/10 to-amber-900/20 border border-amber-500/30">
                    <p className="text-5xl sm:text-6xl font-black text-amber-400 mb-4">${price}</p>
                    
                    {/* Buy Button */}
                    <button
                      onClick={handleCheckout}
                      data-testid="ungating-buy-btn"
                      className="w-full flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-black text-xl rounded-2xl hover:shadow-2xl hover:shadow-amber-500/30 hover:-translate-y-1 transition-all duration-300 mb-6"
                    >
                      <CreditCard className="w-6 h-6" />
                      <span>Купить сейчас</span>
                      <ArrowRight className="w-6 h-6" />
                    </button>
                    
                    {/* Value Propositions */}
                    <div className="space-y-3 text-left">
                      <div className="flex items-start gap-3">
                        <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                        <p className="text-zinc-400 text-sm">
                          <span className="text-red-400 font-semibold">Один неправильный инвойс</span> = риск блокировки аккаунта
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <DollarSign className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                        <p className="text-zinc-400 text-sm">
                          <span className="text-emerald-400 font-semibold">Один открытый бренд</span> = тысячи $ оборота
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <ShieldCheck className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                        <p className="text-zinc-400 text-sm">
                          <span className="text-amber-400 font-semibold">Этот продукт</span> стоит дешевле одной ошибки
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Guarantee */}
                  <div className="flex items-center justify-center gap-2 text-zinc-500 text-base">
                    <ShieldCheck className="w-5 h-5 text-emerald-400" />
                    <span>Безопасная оплата через Stripe</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Back to catalog */}
          <div className="text-center">
            <Link 
              to="/catalog"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-zinc-800 border border-zinc-700 text-zinc-300 hover:text-white hover:bg-zinc-700 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Вернуться в каталог</span>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UngatingPage;
